import { Project, ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

type OldProjectModel = Omit<ProjectModel, 'geoDataByIri'>;

/**
 * Migration to add geoDataByIri to project models and diagram model data
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v44 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v44Projects(prevState.projects);
  }

  return nextState;
};

const v44Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<
      string,
      Project & { modelsById: Record<string, OldProjectModel> }
    >
  ).forEach(([projectId, project]) => {
    const { modelsById, diagram } = project;

    // Add geoDataByIri to all models
    const updatedModelsById: Record<string, ProjectModel> = {};
    Object.entries(modelsById || {}).forEach(([modelId, model]) => {
      updatedModelsById[modelId] = {
        ...model,
        geoDataByIri: {},
      } as ProjectModel;
    });

    // Add geoDataByIri to diagram model data
    const updatedDiagram = diagram.model?.modelData
      ? {
          ...diagram,
          model: {
            ...diagram.model,
            modelData: {
              ...diagram.model.modelData,
              geoDataByIri: {},
            },
          },
        }
      : diagram;

    projectsById[projectId] = {
      ...project,
      modelsById: updatedModelsById,
      diagram: updatedDiagram,
    };
  });

  return { ...prevProjectsState, projectsById };
};
